<template>
  <div>
    <!--  <div class="bannerbox">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <div class="item item1">
            <div class="cont">
              <div class="wrap">
                <div class="tit translateY">新闻标题新闻标题新闻标题新闻标题1</div>
                <div class="text translateY">
                  <p>
                    内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                  </p>
                </div>
                <div class="btn translateY"><span>查看详情</span></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="item item2">
            <div class="cont">
              <div class="wrap">
                <div class="tit translateY">新闻标题新闻标题新闻标题新闻标题2</div>
                <div class="text translateY">
                  <p>
                    内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                  </p>
                </div>
                <div class="btn translateY"><span>查看详情</span></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="item item3">
            <div class="cont">
              <div class="wrap">
                <div class="tit translateY">新闻标题新闻标题新闻标题新闻标题3</div>
                <div class="text translateY">
                  <p>
                    内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                  </p>
                </div>
                <div class="btn translateY"><span>查看详情</span></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="item item4">
            <div class="cont">
              <div class="wrap">
                <div class="tit translateY">新闻标题新闻标题新闻标题新闻标题4</div>
                <div class="text translateY">
                  <p>
                    内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
                  </p>
                </div>
                <div class="btn translateY"><span>查看详情</span></div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination bannerbox-page" slot="pagination"></div>
      </swiper>
      <div class="list">
        <ul class="wrap">
          <li>
            <a href="#" class="li">
              <div class="bg"></div>
              <div class="flex1">
                <h3>标题一标题一标题一标题一</h3>
                <p>简介简介简介简介简介</p>
              </div>
              <img class="img" src="../assets/img/pinceimgfa1.png" />
            </a>
          </li>
          <li>
            <a href="#" class="li">
              <div class="bg"></div>
              <div class="flex1">
                <h3>标题一标题一标题一标题一</h3>
                <p>简介简介简介简介简介</p>
              </div>
              <img class="img" src="../assets/img/pinceimgfa2.png" />
            </a>
          </li>
          <li>
            <a href="#" class="li">
              <div class="bg"></div>
              <div class="flex1">
                <h3>标题一标题一标题一标题一</h3>
                <p>简介简介简介简介简介</p>
              </div>
              <img class="img" src="../assets/img/pinceimgfa3.png" />
            </a>
          </li>
          <li>
            <a href="#" class="li">
              <div class="bg"></div>
              <div class="flex1">
                <h3>标题一标题一标题一标题一</h3>
                <p>简介简介简介简介简介</p>
              </div>
              <img class="img" src="../assets/img/pinceimgfa4.png" />
            </a>
          </li>
        </ul>
      </div>
    </div> -->

    <div id="abouttop" class="aboutus" style="zoom:78%">
      <!-- <div class="page_tit">
      <h3 style="color:#00237d">{{ $t("menus.aboutus") }}</h3>
    </div> -->

      <!--  <div class="banner">
        <img src="../assets/img/banner1.jpg" />
        <div id="aboutpart"></div>
      </div>  -->
      <div class="wrap2">
        <div class="about_box">
          <div class="img"><img src="../assets/img/about_txt.jpg" /></div>
          <div class="text">
            <h2 style="color:#00237d;font-size:45px;">
              {{ $t("menus.aboutus") }}
            </h2>
            <p>
              {{ $t("aboutus.info1") }}
            </p>
            <p>
              {{ $t("aboutus.info2") }}
            </p>
          </div>
        </div>
      </div>
      <div class="wrap2">
        <div class="page_tit fff">
          <h3> 1</h3>
          <p>
            1
          </p>
          <p>1
            
          </p>
          <p>
            1
          </p>
         
        </div>
      </div>
   <!-- <div class="service_box">
      <div class="wrap2">
        <div class="page_tit fff">
          <h3>{{ $t("aboutus.ourservice") }}</h3>
          <p>
            {{ $t("aboutus.ourserviceinfo") }}
          </p>
         
        </div>
        <div class="service_list">
          <ul>
            <li>
              <div class="box">
                <div class="img"><img src="../assets/img/picture3.jpg" /></div>
                <div class="txt">
                  <h3 style="font-size: 20px;">
                    {{ $t("aboutus.ourservice1") }}
                  </h3>
                </div>
              </div>
            </li>
            <li>
              <div class="box">
                <div class="img"><img src="../assets/img/picture4.jpg" /></div>
                <div class="txt">
                  <h3 style="font-size: 20px;">
                    {{ $t("aboutus.ourservice3") }}
                  </h3>
                </div>
              </div>
            </li>
            <li>
              <div class="box">
                <div class="img"><img src="../assets/img/picture11.jpg" /></div>
                <div class="txt">
                  <h3 style="font-size: 20px;">
                    {{ $t("aboutus.ourservice4") }}
                  </h3>
                </div>
              </div>
            </li>
            <li>
              <div class="box">
                <div class="img"><img src="../assets/img/picture5.jpg" /></div>
                <div class="txt">
                  <h3 style="font-size: 20px;">
                    {{ $t("aboutus.ourservice6") }}
                  </h3>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div id="founder"></div>
    </div> -->
   <!--   <div class="about-info">
        <div class="wrap2" style="margin-left: 100px;">
          <div class="flex">
            <div class="info">
              <h2>UC-Elink</h2>
              <h2>{{ $t("aboutus.founder1") }}</h2>
              <div class="line"></div>
              <h3>{{ $t("aboutus.founder2") }}</h3>
              <h4 style="font-size: 32px;line-height: 2cap;">
                {{ $t("aboutus.founder3") }}
              </h4>
              <h4 style="font-size: 32px;line-height: 2cap;;">
                {{ $t("aboutus.founder4") }}
              </h4>
              <div class="des">
                <p style="font-size: 32px;line-height: 2cap;">
                  {{ $t("aboutus.founder5") }}
                </p>
                <div class="txt">
                  <p style="font-size: 32px;line-height: 2cap;">
                    {{ $t("aboutus.founder6") }}
                  </p>
                  <p style="font-size: 32px;line-height: 2cap;">
                    {{ $t("aboutus.founder7") }}
                  </p>
                  <p style="font-size: 32px;line-height: 2cap;">
                    {{ $t("aboutus.founder8") }}
                  </p>
                  <p style="font-size: 32px;line-height: 2cap;">
                    {{ $t("aboutus.founder9") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="img"><img src="../assets/img/img.jpg" /></div>
      </div> -->
      <div class="page_about_box">
        <div class="wrap">
          <h2>{{ $t("aboutus.contactinfo1") }}</h2>
          <p>{{ $t("aboutus.contactinfo2") }}</p>
          <a href="#/contactus" class="btn">{{ $t("aboutus.contactinfo3") }}</a>
        </div>
      </div>
      <div class="page_about_box2">
        <div class="wrap2">
          <h2>{{ $t("aboutus.contactinfo4") }}</h2>
          <ul>
            <li>
              <a href="#"><img src="../assets/img/img17.png"/></a>
            </li>
            <li>
              <a href="#"><img src="../assets/img/img18.png"/></a>
            </li>
            <li>
              <a href="#"><img src="../assets/img/img19.png"/></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      languages: 1,
      /*       swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        }, 
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        effect: "fade",
        on:{
          slideChangeEnd:function(swiper){
console.log(swiper.activeIndex)
        }}
      }, */
    };
  },

  computed: {
    ProList() {
      return [
        {
          img: require("../assets/img/picture1.jpg"),
          tit: this.$t("aboutus.team"),
          des: "",
        },
        {
          img: require("../assets/img/picture2.jpg"),
          tit: this.$t("aboutus.client"),
          des: "",
        },
        {
          img: require("../assets/img/picture3.jpg"),
          tit: this.$t("aboutus.network"),
          des: "",
        },
        {
          img: require("../assets/img/picture4.jpg"),
          tit: this.$t("aboutus.onoffline"),
          des: "",
        },
      ];
    },
  },

  mounted() {
    if (this.$route.query.id) {
      document.getElementById(this.$route.query.id).scrollIntoView();
      if (this.$route.query.id == "abouttop") {
        document.documentElement.scrollTop = 0;
      }
    }
    // const hash = this.$route.hash;
    // if (hash) {
    //   this.$nextTick(() => {
    //     const position = document.getElementById(hash.substring(1));
    //     if (position) {
    //       console.log(position);
    //       position.scrollIntoView();
    //     }
    //   });
    // }
  },

  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.id) {
          document.getElementById(this.$route.query.id).scrollIntoView();
        }
        if (this.$route.query.id == "abouttop") {
          document.documentElement.scrollTop = 0;
        }
      },
    },
  },

  components: {},
  created() {
    //console.log(this.$i18n.locale);
    if (this.$i18n.locale == "zh") {
      this.languages = 1;
      console.log("1111111");
    } else {
      this.languages = 2;
      console.log("22222222");
    }
    console.log(this.languages);
  },
};
</script>

<style lang="scss" scoped>
.wrap2 {
  max-width: 1200px;
  margin: 0 auto;
  width: 96%;
}
.about_box .img {
  width: 300px;
  margin-right: 100px;
}
</style>
